export default function ArticleSkeleton() {
  return (
    <div className="bg-[#FDF8F1] animate-pulse" aria-busy="true">
      {/* Header */}
      <header className="px-6 pt-10 md:pt-14 pb-10">
        <div className="max-w-3xl mx-auto">
          <div className="h-5 w-32 bg-[#A7D3AF]/50 rounded-full mb-8" />
          <div className="flex gap-2 mb-5">
            <div className="h-6 w-24 bg-[#A7D3AF]/50 rounded-full" />
            <div className="h-6 w-20 bg-[#FFE37B]/60 rounded-full" />
          </div>
          <div className="space-y-3 mb-5">
            <div className="h-10 w-full bg-[#064E3B]/10 rounded-xl" />
            <div className="h-10 w-3/4 bg-[#064E3B]/10 rounded-xl" />
          </div>
          <div className="h-6 w-5/6 bg-[#064E3B]/5 rounded-lg mb-8" />
          <div className="flex items-center gap-6">
            <div className="w-10 h-10 bg-[#008D63]/20 rounded-full" />
            <div className="h-4 w-24 bg-[#064E3B]/10 rounded" />
            <div className="h-4 w-28 bg-[#064E3B]/10 rounded" />
          </div>
        </div>
      </header>

      {/* Cover */}
      <div className="px-4 md:px-10">
        <div className="max-w-5xl mx-auto aspect-[16/9] rounded-[32px] md:rounded-[40px] bg-[#064E3B]/10" />
      </div>

      {/* Content */}
      <div className="px-6 py-12 md:py-16">
        <div className="max-w-3xl mx-auto bg-white rounded-[32px] px-6 py-8 md:px-12 md:py-12 space-y-8">
          <div className="space-y-3">
            <div className="h-4 w-full bg-[#064E3B]/5 rounded" />
            <div className="h-4 w-full bg-[#064E3B]/5 rounded" />
            <div className="h-4 w-5/6 bg-[#064E3B]/5 rounded" />
          </div>
          <div className="h-7 w-2/3 bg-[#064E3B]/10 rounded-lg" />
          <div className="space-y-3">
            <div className="h-4 w-full bg-[#064E3B]/5 rounded" />
            <div className="h-4 w-11/12 bg-[#064E3B]/5 rounded" />
            <div className="h-4 w-full bg-[#064E3B]/5 rounded" />
            <div className="h-4 w-4/5 bg-[#064E3B]/5 rounded" />
          </div>
          <div className="pt-8 border-t-2 border-dashed border-[#A7D3AF] flex gap-3">
            <div className="h-8 w-24 bg-[#A7D3AF]/40 rounded-lg" />
            <div className="h-8 w-20 bg-[#A7D3AF]/40 rounded-lg" />
            <div className="h-8 w-28 bg-[#A7D3AF]/40 rounded-lg" />
          </div>
        </div>
      </div>
    </div>
  );
}
